export const URL_HOME =
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=21.1702401&lng=72.83106070000001&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";
export const IMG_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_288,h_360/";
export const REST_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
export const REST_MENU_URL =
  "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=21.1702401&lng=72.8310607000000&restaurantId=";
export const Search_URL =
  "https://www.swiggy.com/dapi/restaurants/search/suggest?lat=21.18880&lng=72.82930&str=";
export const PRE_SEARCH =
  "https://www.swiggy.com/dapi/landing/PRE_SEARCH?lat=21.1702401&lng=72.8310607000000";
// const INPUT_AUTOCOMPLETE =
//   "https://www.swiggy.com/dapi/misc/place-autocomplete?input=Banglore&types=";
// const AFTER_SEARCH =
//   "https://www.swiggy.com/dapi/misc/address-recommend?place_id=ChIJbU60yXAWrjsR4E9-UejD3_g";
